module.exports = __webpack_public_path__ + "img/startup_founders_talk_brang_logo.18277f13.png";